import { isInternalLink } from "@/lib/broadcast";

/**
 * Tujuan ketukan sebuah notifikasi pembeli — dipakai daftar `/notifications`
 * DAN banner notifikasi masuk (`NotificationBanner`), jadi keduanya mendarat
 * di halaman yang sama. Dipindah apa adanya dari `NotificationsClient`
 * (2026-09-24).
 */
export function getNotifRoute(
  type: string,
  referenceId: string | null,
  link?: string | null
): string {
  // Deep-link eksplisit (kolom notifications.link) menang bila path internal —
  // dipakai broadcast admin & notif auto-ship "Nota + Kirim" (mig 158).
  if (link && isInternalLink(link)) return link;
  switch (type) {
    case "admin_broadcast":
      // Broadcast admin tanpa link valid → daftar notif.
      return "/notifications";
    case "po_closed":
    case "production_started":
      return "/orders?tab=belum-ready";
    case "item_ready":
      // reference_id = order_items.id. Notifnya berbunyi "Segera pilih untuk
      // dikirim!", jadi ketukannya mendarat di halaman aksi dengan barang yang
      // dimaksud SUDAH tercentang — bukan di keranjang berisi puluhan baris
      // yang harus dicari sendiri. Item yang ternyata sudah tak memenuhi
      // syarat (sudah dinotakan/dikirim di sela itu) tidak menggagalkan apa
      // pun: halamannya berdiri sebagai pemilih penuh.
      return referenceId
        ? `/orders/tagihan-kirim?items=${encodeURIComponent(referenceId)}`
        : "/orders?tab=keranjang";
    case "keep_expired":
    case "keep_expiring_soon":
    case "order_cancelled":
    case "order_updated":
    case "production_failed":
      return "/orders?tab=keranjang";
    case "shipment_ongkir_set":
    case "shipment_payment_confirmed":
    case "item_shipped":
      // reference_id = shipment_request.id → buka detail pengiriman itu.
      return referenceId
        ? `/orders/pengiriman/${referenceId}`
        : "/orders?tab=pengiriman";
    case "invoice_issued":
    case "invoice_paid":
    case "invoice_rejected":
      // reference_id = invoice.id → buka detail nota itu.
      return referenceId ? `/orders/tagihan/${referenceId}` : "/tagihan";
    case "topup_approved":
    case "topup_rejected":
    case "balance_credited":
    case "balance_debited":
      return "/saldo";
    case "level_up":
      return "/account";
    case "feedback_replied":
      // reference_id = feedback.id; halaman kritik & saran menampilkan riwayat
      // kiriman pembeli berikut balasannya, jadi cukup mendarat di sana.
      return "/account/kritik-saran";
    case "membership_expiring_soon":
    case "membership_expired":
      return "/mitra";
    case "points_earned":
    case "redemption_fulfilled":
    case "redemption_rejected":
    case "points_revoked":
    case "points_expiring_soon":
    case "points_expired":
      return "/poin";
    default:
      return "/orders";
  }
}
